import React from 'react';
import { ManagementCompanyTag } from '../Tags';
import { ManagementCompanyCard as GridView } from './GridView/ManagementCompanyCard';
import { ManagementCompanyLink } from './Link';
import { ManagementCompanyText } from './Text';
import { Small, Medium, Large } from './Cards';
export var ManagementCompany = function ManagementCompany(_ref) {
  var managementCompany = _ref.managementCompany,
    variant = _ref.variant,
    productType = _ref.productType,
    _ref$isPartner = _ref.isPartner,
    isPartner = _ref$isPartner === void 0 ? false : _ref$isPartner;
  if (isPartner) managementCompany.isPartner = true;
  switch (variant) {
    case 'smallCard':
      return React.createElement(Small, {
        managementCompany: managementCompany,
        productType: productType
      });
    case 'mediumCard':
      return React.createElement(Medium, {
        managementCompany: managementCompany,
        productType: productType
      });
    case 'largeCard':
      return React.createElement(Large, {
        managementCompany: managementCompany,
        productType: productType
      });
    case 'link':
      return React.createElement(ManagementCompanyLink, {
        entity: managementCompany,
        productType: productType
      });
    case 'tag':
      return React.createElement(ManagementCompanyTag, {
        entity: managementCompany,
        productType: productType
      });
    case 'text':
      return React.createElement(ManagementCompanyText, {
        entity: managementCompany,
        productType: productType
      });
    default:
      return React.createElement(GridView, {
        managementCompany: managementCompany,
        productType: productType
      });
  }
};